import React from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import "./index.scss";

const links=[
  {to:"/economics",label:"Overview",end:true},
  {to:"/economics/history",label:"History"},
  {to:"/economics/calendar",label:"Calendar"},
  {to:"/economics/system",label:"System map"},
  {to:"/economics/scenarios",label:"Scenarios"},
];

export default function EconomicsWorkspace():JSX.Element{
  return <main className="economics-page">
    <header className="economics-shell-header">
      <Link className="economics-brand" to="/">calvinlee.dev</Link>
      <nav aria-label="Economics sections">
        {links.map(link=><NavLink key={link.to} end={link.end} to={link.to} className={({isActive})=>isActive?"active":""}>{link.label}</NavLink>)}
      </nav>
    </header>
    <Outlet/>
    <footer className="economics-footer">
      <p>Measured facts, structural relationships, and rule-based scenarios are educational context—not proof of causality, forecasts, or personalized financial advice.</p>
      <p>“Federal rate” is represented by the federal funds target range and the effective federal funds rate. Data is retrieved through FRED and attributed to each originating agency.</p>
    </footer>
  </main>;
}
